import './index.scss';
import React, { useState, useEffect } from 'react';
import { List } from 'antd-mobile';
import { useHistory } from 'react-router';
import { getUser, logout, getBooleanValue, getStringValue, getParamBiz } from '../../utils';
import avator from '../../images/ico_user_avator.png';
import sysConfig from '../../sysConfig';

const { preRouteUrl } = sysConfig;
const Item = List.Item;

function Personal() {
  const history = useHistory();
  const { photo, userName, schoolName } = getUser() || {};
  const [version, setVersion] = useState('');
  const { third_login_address_h5 } = getParamBiz() || {};

  useEffect(() => {
    const versionStr = getStringValue('VERSION', '1.0', (value) => {
      setVersion(value);
    });
    if (versionStr) {
      setVersion(versionStr);
    }
    // getNotifyUnread();
  }, []);

  return (
    <div className="personal">
      <List>
        <Item
          arrow={false}
          style={{ paddingTop: getBooleanValue('IS_IMMERSE', false) ? '6vw' : 0 }}
          // onClick={() => {
          //   console.log(11);
          // }}
        >
          <div className="personal-info">
            {/* <NavBar
              mode="light"
              className="header"
              rightContent={[
                <div
                  className="news-notice"
                  onClick={() => {
                    history.push(`${preRouteUrl}/personal/notifyUser`);
                  }}
                >
                  <span>{unreadNum}</span>
                </div>,
              ]}
            /> */}
            <div className="photo">
              <img
                src={photo || avator}
                alt="avator"
                onError={(e) => {
                  e.target.setAttribute('src', avator);
                }}
              />
            </div>
            <p className="user-name">{userName || '无用户数据'}</p>
            <p className="user-school">{schoolName || '无用户数据'}</p>
          </div>
        </Item>
      </List>
      <List style={{ marginTop: '5.6vw' }}>
        <Item
          className="set-item"
          thumb={<em className="icon setting" />}
          arrow="horizontal"
          onClick={() => {
            history.push(`${preRouteUrl}/personal/setting`);
          }}
        >
          设置
        </Item>
        <Item
          className="set-item"
          thumb={<em className="icon password" />}
          arrow="horizontal"
          onClick={() => {
            history.push(`${preRouteUrl}/personal/modifyPassword`);
          }}
        >
          修改密码
        </Item>
        <Item
          className="set-item"
          thumb={<em className="icon version" />}
          arrow="empty"
          extra={<span style={{ letterSpacing: '.5vw' }}>{version}</span>}
        >
          版本信息
        </Item>
        {/* <Item
          className="set-item"
          thumb={<em className="icon cookie" />}
          arrow="empty"
          onClick={() => {
            console.log(11);
          }}
        >
          缓存清理
        </Item> */}
      </List>
      {third_login_address_h5 ? null : (
        <List style={{ marginTop: '5.6vw' }}>
          <Item
            onClick={() => {
              logout();
            }}
          >
            <div style={{ textAlign: 'center' }}>退出登录</div>
          </Item>
        </List>
      )}
    </div>
  );
}

export default Personal;
